import PropTypes from "prop-types";

export default function FormSelect({
  id,
  label,
  name,
  value = "",
  onChange,
  options,
  placeholder = "Select…",
  disabled,
  error,
  className = "",
  /** Rendered on the same row as the label (e.g. link / icon button). */
  labelAction = null,
}) {
  const inputId = id || name;

  return (
    <div className={className}>
      <div className="mb-1 flex min-h-[1.25rem] items-center justify-between gap-2">
        <label htmlFor={inputId} className="text-xs font-semibold text-black">
          {label}
        </label>
        {labelAction ? <span className="shrink-0">{labelAction}</span> : null}
      </div>
      <div className="relative">
        <select
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          aria-invalid={Boolean(error)}
          className={[
            "w-full appearance-none rounded-lg border px-3 py-2.5 text-sm outline-none transition ring-brand-600 focus:ring-2",
            error ? "border-red-400 bg-red-50/40" : "border-slate-500 bg-white",
            value ? "text-text-900" : "text-text-500",
          ].join(" ")}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-text-500">▾</span>
      </div>
      {error ? (
        <p id={`${inputId}-error`} className="mt-1 text-xs font-medium text-red-600" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

FormSelect.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  labelAction: PropTypes.node,
};
